module.exports = __webpack_public_path__ + "./Popup-58e1d4210f7a8c536ff6b4b7e2c9c7fd.css";